// import { baseApi } from "./baseApi";

// export const clientDashboardApi = baseApi.injectEndpoints({
//   endpoints: (builder) => ({
//     getDashboard: builder.query<any, { lat: number; lng: number }>({
//       query: ({ lat, lng }) => ({
//         url: "/dashboard",
//         method: "GET",
//         params: { lat, lng }, // <-- CORRECT WAY TO PASS QUERY PARAMS
//       }),
//       transformResponse: (response: any) => response,
//       providesTags: ["dashboard"],
//     }),
//   }),
// });

// export const { useGetDashboardQuery, useLazyGetDashboardQuery } =
//   clientDashboardApi;


import { baseApi } from "./baseApi";

export interface RecentOrder {
  order_id: string;
  order_type: string;
  price: string;
  status: string;
  created_at: string;
}

export interface RecentOrdersMeta {
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
}

export interface RecentOrdersResponse {
  status: boolean;
  data: RecentOrder[];
  meta: RecentOrdersMeta;
}

export interface RecentOrdersParams {
  perPage?: number;
  status?: string;
  sortBy?: "asc" | "desc";
}

export interface ChecklistItem {
  key: string;
  label: string;
  completed: boolean;
}

export interface OnboardingChecklistResponse {
  status: string;
  data: {
    checklist: ChecklistItem[];
    completed_count: number;
    total_count: number;
    all_done: boolean;
  };
}

export const clientDashboardApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboard: builder.query<any, { lat: number; lng: number }>({
      query: ({ lat, lng }) => ({
        url: "/dashboard",
        method: "GET",
        params: { lat, lng },
      }),
      transformResponse: (response: any) => response,
      providesTags: ["dashboard"],
    }),

    getRecentOrders: builder.query<RecentOrdersResponse, RecentOrdersParams>({
      query: (params) => ({
        url: "/dashboard/recent-orders",
        method: "GET",
        params,
      }),
      transformResponse: (response: any) => response,
      providesTags: ["dashboard"],
    }),

    getOnboardingChecklist: builder.query<OnboardingChecklistResponse, void>({
      query: () => ({
        url: "/checklist/onboarding",
        method: "GET",
      }),
      providesTags: ["OnboardingChecklist"],
    }),
  }),
});

export const {
  useGetDashboardQuery,
  useLazyGetDashboardQuery,
  useGetRecentOrdersQuery,
  useLazyGetRecentOrdersQuery,
  useGetOnboardingChecklistQuery,
} = clientDashboardApi;